import PropTypes from 'prop-types';
import React from 'react';
import { AppBar, Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LocaleSelect from './LocaleSelect';
import Logo from './Logo';
import Content from './Content';

const useStyles = makeStyles(() => ({
  grid: {
    width: '100%',
    margin: 0,
  },
}));

const MainBarMobile = ({ email, location }) => {
  const classes = useStyles();
  return (
    <AppBar color="default" position="static">
      <Container>
        <Grid className={classes.grid} container direction="column" justifyContent="flex-start" alignItems="center" spacing={2}>
          <Grid item container alignItems="flex-end" spacing={1}>
            <LocaleSelect location={location} isMobile />
          </Grid>
          <Grid item container justifyContent="center" alignItems="center">
            <Logo />
          </Grid>
          <Grid item>
            <Content email={email} isMobile />
          </Grid>
        </Grid>
      </Container>
    </AppBar>
  );
};

MainBarMobile.propTypes = {
  email: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
};

export default MainBarMobile;
